import { Spinner } from '@ui';

interface Props {
    empty?: boolean;
}

export const SpaceTableLoader = ({ empty }: Props) => {
    return (
        <div className="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center [&>h5]:tw-mt-[2rem]">
            {empty ? (
                <p>Es wurden noch keine Plätze erstellt!</p>
            ) : (
                <>
                    <Spinner />
                    <h5>Lade Plätze ...</h5>
                </>
            )}
        </div>
    );
};
